const _uppercasePattern = /([A-Z])/g;
function hyphenate(str) {
  return str.replace(_uppercasePattern, '-$1').toLowerCase();
}
function hyphenateStyleName(str) {
  return hyphenate(str);
}
const styleProperties = element => {
  return {
    get: () => {
      return element === null || element === void 0 ? void 0 : element.style;
    },
    set: styleObject => {
      Object.entries(styleObject).forEach(_ref => {
        let [key, value] = _ref;
        return element === null || element === void 0 ? void 0 : element.style.setProperty(hyphenateStyleName(key), value);
      });
    },
    remove: styleObject => {
      Object.keys(styleObject).forEach(key => element === null || element === void 0 ? void 0 : element.style.removeProperty(hyphenateStyleName(key)));
    },
    setClass: className => {
      return element === null || element === void 0 ? void 0 : element.classList.add(className);
    },
    removeClass: className => {
      return element === null || element === void 0 ? void 0 : element.classList.remove(className);
    }
  };
};
// @see https://github.com/gregberge/react-merge-refs/blob/main/src/index.tsx
function mergeRefs(refs) {
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}

export { mergeRefs, styleProperties };
